exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-image-viewer__svg svg{min-width:0.52083rem;min-height:0.52083rem}\n", ""]);

// exports
